module.exports = __webpack_public_path__ + "img/maDianCan.4da0d709.png";